import React, { useEffect, useRef, useState } from "react";
import AdminNavbar from "../Navbar/AdminNavbar";
import { useSelector } from "react-redux";
import {
  GetContent,
  GetContentAll,
  GetLevel1,
  GetLevel1All,
  GetLevel2,
  GetLevel2All,
  GetMain,
  GetSpecificContent,
  GetSpecificMain,
  GetUser,
  UpdateContent,
  UpdateMain,
} from "../../../Api/Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../Spinner/Spinner";
import "./ContentEdit.css";

export default function ContentEdit() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const { id } = useParams();

  const [getMyTaskMain, setGetMyTaskMain] = useState([]);
  const [getMyTasklevel1, setGetMyTasklevel1] = useState([]);
  const [getMyTasklevel2, setGetMyTasklevel2] = useState([]);

  const [myTask1, setMyTask1] = useState({});
  const [content, setContent] = useState("");
  const [content1, setContent1] = useState("");
  const [slugValue, setSlugValue] = useState("");
  const [change, setChange] = useState(false);
  const [change1, setChange1] = useState(false);

  // Success Toast
  const showToastSuccessMsg = (successMsg) => {
    toast.success(successMsg, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
      autoClose: 4000,
    });
  };

  // Error Toast
  const showToastErrorMsg = (errMsg) => {
    toast.error(errMsg, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
      autoClose: 5000,
    });
  };

  const GetMyTsksMain = async () => {
    let data = await GetMain("active");
    if (data && data.statusCode === 200) {
      setGetMyTaskMain(data.data || []);
    } else {
      setGetMyTaskMain([]);
    }
  };

  const GetMyTsksLevel1All = async () => {
    let data = await GetLevel1All("active");
    if (data && data.statusCode === 200) {
      setGetMyTasklevel1(data.data || []);
    } else {
      setGetMyTasklevel1([]);
    }
  };

  const GetMyTsksLevel2All = async () => {
    let data = await GetLevel2All("active");
    if (data && data.statusCode === 200) {
      setGetMyTasklevel2(data.data || []);
    } else {
      setGetMyTasklevel2([]);
    }
  };

  const setMyTaskValue1 = (parentKey, childKey, value, type) => {
    if (type === "object") {
      setMyTask1((prev) => ({
        ...prev,
        [parentKey]: { ...(prev[parentKey] || {}), [childKey]: value },
      }));
    } else {
      setMyTask1((prev) => ({
        ...prev,
        [childKey]: value,
      }));
    }
  };

  const GetMySpecificTsks = async () => {
    setLoading(true);
    try {
      const data = await GetSpecificContent(id);
      if (data && data.statusCode === 200 && data.data) {
        const item = data.data;
        setMyTask1(item);
        setContent(item.content || "");
        setContent1(item.serviceIncludedIn || "");

        // Determine target service object to read slug
        const targetService = item.subServiceL2Id || item.subServiceL1Id || item.mainServiceId;
        let initialSlug = targetService?.slug || "";

        // If populated service does not contain slug, fetch directly
        const serviceId = targetService?._id || targetService;
        if (!initialSlug && serviceId) {
          try {
            const srvData = await GetSpecificMain(serviceId);
            if (srvData && srvData.statusCode === 200 && srvData.data?.slug) {
              initialSlug = srvData.data.slug;
            }
          } catch (e) {
            console.error("Failed to fetch service detail for slug", e);
          }
        }
        setSlugValue(initialSlug || "");
      } else {
        setMyTask1({});
        setContent("");
        setContent1("");
        setSlugValue("");
      }
    } catch (err) {
      console.error("Error fetching content details", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetMySpecificTsks();
    GetMyTsksMain();
    GetMyTsksLevel1All();
    GetMyTsksLevel2All();
  }, [id]);

  const handleUpdateSubmit = async (e) => {
    if (e) e.preventDefault();
    setSaving(true);

    const token = state?.auth?.auth?.token;
    const targetService = myTask1?.subServiceL2Id || myTask1?.subServiceL1Id || myTask1?.mainServiceId;
    const serviceIdToUpdate = targetService?._id || targetService;

    // Save slug to services collection if present
    if (serviceIdToUpdate && slugValue) {
      try {
        await UpdateMain({ _id: serviceIdToUpdate, slug: slugValue.trim() }, token);
      } catch (err) {
        console.error("Failed to update slug on service", err);
      }
    }

    const Payload = {
      _id: myTask1?._id,
      status: myTask1?.status || "active",
      content: change ? content : (myTask1?.content || ""),
      mainServiceId: myTask1?.mainServiceId?._id ? myTask1.mainServiceId._id : myTask1?.mainServiceId,
      subServiceL1Id: myTask1?.subServiceL1Id?._id ? myTask1.subServiceL1Id._id : myTask1?.subServiceL1Id,
      subServiceL2Id: myTask1?.subServiceL2Id?._id ? myTask1.subServiceL2Id._id : myTask1?.subServiceL2Id,
      dynamicPricingFlag: myTask1?.dynamicPricingFlag,
      dynamicServiceFlag: myTask1?.dynamicServiceFlag,
      serviceIncludedIn: change1 ? content1 : (myTask1?.serviceIncludedIn || ""),
      metaTitle: myTask1?.metaTitle || "",
      metaKeyword: myTask1?.metaKeyword || "",
      metaDescription: myTask1?.metaDescription || "",
      addBy: myTask1?.addBy?._id ? myTask1.addBy._id : (state?.auth?.auth?._id || myTask1?.addBy),
      pricing: {
        marketPrice: myTask1?.pricing?.marketPrice || "",
        companyPrice: myTask1?.pricing?.companyPrice || "",
        gst: myTask1?.pricing?.gst || "",
      },
    };

    try {
      const response = await UpdateContent(Payload, token);
      if (response && response.statusCode === 200) {
        showToastSuccessMsg(response.message || "Content updated successfully!");
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        showToastErrorMsg(
          response?.message || response?.error?.response?.data?.message || "Failed to update content"
        );
      }
    } catch (error) {
      showToastErrorMsg("An unexpected error occurred while saving.");
    } finally {
      setSaving(false);
    }
  };

  const hasPricing = Boolean(
    myTask1?.dynamicPricingFlag ||
    (myTask1?.pricing && (myTask1.pricing.marketPrice || myTask1.pricing.companyPrice || myTask1.pricing.gst))
  );

  return (
    <div>
      <AdminNavbar />
      <ToastContainer />

      <div className="main content-edit-main-container">
        <div className="content-edit-wrapper">
          {/* Top Header & Actions */}
          <div className="content-edit-header-bar">
            <div>
              <button
                type="button"
                className="btn-back-modern"
                onClick={() => navigate("/Content")}
              >
                <i className="fa fa-arrow-left"></i>
                <span>Back to Content List</span>
              </button>
              <h3 className="mt-3 mb-1 fw-bold" style={{ color: "#0f172a", letterSpacing: "-0.02em" }}>
                Edit Service Content
              </h3>
              <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                Configure service routing, page description, and SEO metadata
              </p>
            </div>

            <div>
              <button
                type="button"
                className="btn-save-modern"
                disabled={loading || saving}
                onClick={handleUpdateSubmit}
              >
                {saving ? (
                  <>
                    <i className="fa fa-circle-o-notch fa-spin"></i>
                    <span>Saving...</span>
                  </>
                ) : (
                  <>
                    <i className="fa fa-check"></i>
                    <span>Save Changes</span>
                  </>
                )}
              </button>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <Spinner />
            </div>
          ) : (
            <form onSubmit={handleUpdateSubmit}>
              {/* Card 1: Service Categorization */}
              <div className="content-edit-card">
                <div className="card-header-styled">
                  <div className="card-header-icon">
                    <i className="fa fa-sitemap"></i>
                  </div>
                  <div>
                    <h5 className="card-header-title">Service Hierarchy & Classification</h5>
                    <p className="card-header-desc">Assign this content to its corresponding service level</p>
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-lg-4 col-md-6">
                    <label className="form-label-modern">
                      Main Service <span className="badge-tag">Level 0</span>
                    </label>
                    <select
                      className="form-control form-control-modern"
                      style={{ textTransform: "capitalize" }}
                      value={myTask1?.mainServiceId?.title || ""}
                      onChange={(e) => {
                        const selected = getMyTaskMain.find((s) => s.title === e.target.value);
                        if (selected) {
                          setMyTaskValue1("", "mainServiceId", selected._id, "");
                          setMyTask1((prev) => ({
                            ...prev,
                            mainServiceId: selected,
                          }));
                        }
                      }}
                    >
                      <option value="">--- Select Main Service ---</option>
                      {getMyTaskMain?.map((e) => (
                        <option key={e._id} value={e.title}>
                          {e.title}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-4 col-md-6">
                    <label className="form-label-modern">
                      Sub Service <span className="badge-tag">Level 1</span>
                    </label>
                    <select
                      className="form-control form-control-modern"
                      style={{ textTransform: "capitalize" }}
                      value={myTask1?.subServiceL1Id?.title || ""}
                      onChange={(e) => {
                        const selected = getMyTasklevel1.find((s) => s.title === e.target.value);
                        if (selected) {
                          setMyTaskValue1("", "subServiceL1Id", selected._id, "");
                          setMyTask1((prev) => ({
                            ...prev,
                            subServiceL1Id: selected,
                          }));
                        }
                      }}
                    >
                      <option value="">--- Select Level 1 ---</option>
                      {getMyTasklevel1?.map((e) => (
                        <option key={e._id} value={e.title}>
                          {e.title}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-4 col-md-12">
                    <label className="form-label-modern">
                      Sub Service <span className="badge-tag">Level 2</span>
                    </label>
                    <select
                      className="form-control form-control-modern"
                      style={{ textTransform: "capitalize" }}
                      value={myTask1?.subServiceL2Id?.title || ""}
                      onChange={(e) => {
                        const selected = getMyTasklevel2.find((s) => s.title === e.target.value);
                        if (selected) {
                          setMyTaskValue1("", "subServiceL2Id", selected._id, "");
                          setMyTask1((prev) => ({
                            ...prev,
                            subServiceL2Id: selected,
                          }));
                        }
                      }}
                    >
                      <option value="">--- Select Level 2 ---</option>
                      {getMyTasklevel2?.map((e) => (
                        <option key={e._id} value={e.title}>
                          {e.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Card 2: Routing & URL Slug */}
              <div className="content-edit-card">
                <div className="card-header-styled">
                  <div className="card-header-icon" style={{ background: "#eef2ff", color: "#4f46e5" }}>
                    <i className="fa fa-link"></i>
                  </div>
                  <div>
                    <h5 className="card-header-title">URL Slug & Service Route</h5>
                    <p className="card-header-desc">Defines the clean, human-readable URL path for this service</p>
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-lg-8">
                    <label className="form-label-modern">
                      URL Slug <span className="text-danger">*</span>
                    </label>
                    <div className="slug-input-wrapper">
                      <span className="slug-prefix-badge">/service/</span>
                      <input
                        type="text"
                        className="form-control form-control-modern form-control-slug"
                        placeholder="e.g. general-cleaning"
                        value={slugValue}
                        onChange={(e) => {
                          const sanitized = e.target.value
                            .toLowerCase()
                            .replace(/\s+/g, "-")
                            .replace(/[^\w\-]+/g, "")
                            .replace(/\-\-+/g, "-");
                          setSlugValue(sanitized);
                        }}
                        autoComplete="off"
                      />
                    </div>
                    <div className="slug-helper-text">
                      <i className="fa fa-info-circle me-1"></i>
                      This slug is automatically synchronized with the service route and frontend navigation links.
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <label className="form-label-modern">Publication Status</label>
                    <select
                      className="form-control form-control-modern"
                      value={myTask1?.status || "active"}
                      onChange={(e) => setMyTaskValue1("", "status", e.target.value, "")}
                    >
                      <option value="active">Active (Visible)</option>
                      <option value="inactive">Inactive (Hidden)</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Card 3: Main Page Content */}
              <div className="content-edit-card">
                <div className="card-header-styled">
                  <div className="card-header-icon" style={{ background: "#f0fdf4", color: "#16a34a" }}>
                    <i className="fa fa-align-left"></i>
                  </div>
                  <div>
                    <h5 className="card-header-title">Primary Content & Description</h5>
                    <p className="card-header-desc">Detailed rich text overview displayed on the service landing page</p>
                  </div>
                </div>

                <div>
                  <SunEditor
                    setContents={content}
                    onChange={(e) => {
                      setChange(true);
                      setContent(e);
                    }}
                    setDefaultStyle="font-family: Inter, -apple-system, sans-serif; font-size: 15px; line-height: 1.6; color: #1e293b;"
                    setOptions={{
                      buttonList: [
                        ["undo", "redo"],
                        ["font", "fontSize", "formatBlock"],
                        ["bold", "underline", "italic", "strike", "subscript", "superscript"],
                        ["fontColor", "hiliteColor", "textStyle"],
                        ["removeFormat"],
                        ["outdent", "indent"],
                        ["align", "horizontalRule", "list", "lineHeight"],
                        ["table", "link", "image", "video"],
                        ["fullScreen", "showBlocks", "codeView"],
                      ],
                      lineHeights: [
                        { text: "1.0", value: 1 },
                        { text: "1.2", value: 1.2 },
                        { text: "1.5", value: 1.5 },
                        { text: "1.8", value: 1.8 },
                        { text: "2.0", value: 2 },
                      ],
                      minHeight: "340px",
                    }}
                  />
                </div>
              </div>

              {/* Card 4: Service Included In (Optional / Flagged) */}
              {/* {(myTask1?.dynamicServiceFlag || content1) && (
              <div className="content-edit-card">
                <div className="card-header-styled">
                  <div className="card-header-icon" style={{ background: "#fef3c7", color: "#d97706" }}>
                    <i className="fa fa-check-square-o"></i>
                  </div>
                  <div>
                    <h5 className="card-header-title">Service Inclusions</h5>
                    <p className="card-header-desc">Specify what deliverables and tasks are included in this package</p>
                  </div>
                </div>

                <div>
                  <SunEditor
                    setContents={content1}
                    onChange={(e) => {
                      setChange1(true);
                      setContent1(e);
                    }}
                    setDefaultStyle="font-family: Inter, -apple-system, sans-serif; font-size: 15px; line-height: 1.6; color: #1e293b;"
                    setOptions={{
                      buttonList: [
                        ["undo", "redo"],
                        ["font", "fontSize", "formatBlock"],
                        ["bold", "underline", "italic"],
                        ["list", "align", "table"],
                        ["link", "image"],
                        ["fullScreen", "codeView"],
                      ],
                      minHeight: "220px",
                    }}
                  />
                </div>
              </div>
            )} */}

              {/* Card 5: Pricing Configuration (If Applicable) */}
              {/* {hasPricing && (
              <div className="content-edit-card">
                <div className="card-header-styled">
                  <div className="card-header-icon" style={{ background: "#ecfeff", color: "#0891b2" }}>
                    <i className="fa fa-tag"></i>
                  </div>
                  <div>
                    <h5 className="card-header-title">Pricing Details</h5>
                    <p className="card-header-desc">Set market rates, company pricing, and tax configuration</p>
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-lg-4 col-md-6">
                    <label className="form-label-modern">Market Price (AED / SAR)</label>
                    <input
                      type="text"
                      className="form-control form-control-modern"
                      placeholder="e.g. 150"
                      value={myTask1?.pricing?.marketPrice || ""}
                      onChange={(e) => setMyTaskValue1("pricing", "marketPrice", e.target.value, "object")}
                      autoComplete="off"
                    />
                  </div>
                  <div className="col-lg-4 col-md-6">
                    <label className="form-label-modern">Company Price</label>
                    <input
                      type="text"
                      className="form-control form-control-modern"
                      placeholder="e.g. 120"
                      value={myTask1?.pricing?.companyPrice || ""}
                      onChange={(e) => setMyTaskValue1("pricing", "companyPrice", e.target.value, "object")}
                      autoComplete="off"
                    />
                  </div>
                  <div className="col-lg-4 col-md-12">
                    <label className="form-label-modern">GST / VAT %</label>
                    <input
                      type="text"
                      className="form-control form-control-modern"
                      placeholder="e.g. 5"
                      value={myTask1?.pricing?.gst || ""}
                      onChange={(e) => setMyTaskValue1("pricing", "gst", e.target.value, "object")}
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>
            )} */}

              {/* Card 6: SEO Metadata */}
              <div className="content-edit-card">
                <div className="card-header-styled">
                  <div className="card-header-icon" style={{ background: "#faf5ff", color: "#9333ea" }}>
                    <i className="fa-solid fa-magnifying-glass"></i>
                  </div>
                  <div>
                    <h5 className="card-header-title">SEO & Metadata Optimization</h5>
                    <p className="card-header-desc">Optimize this service for search engine rankings and social sharing</p>
                  </div>
                </div>

                <div className="row g-3">
                  <div className="col-lg-6">
                    <label className="form-label-modern">Meta Title</label>
                    <input
                      type="text"
                      className="form-control form-control-modern"
                      placeholder="Enter meta title for Google search"
                      value={myTask1?.metaTitle || ""}
                      onChange={(e) => setMyTaskValue1("", "metaTitle", e.target.value, "")}
                      autoComplete="off"
                    />
                  </div>

                  <div className="col-lg-6">
                    <label className="form-label-modern">Meta Keywords</label>
                    <input
                      type="text"
                      className="form-control form-control-modern"
                      placeholder="e.g. cleaning, maintenance, plumbing"
                      value={myTask1?.metaKeyword || ""}
                      onChange={(e) => setMyTaskValue1("", "metaKeyword", e.target.value, "")}
                      autoComplete="off"
                    />
                  </div>

                  <div className="col-lg-12">
                    <label className="form-label-modern">Meta Description</label>
                    <textarea
                      className="form-control form-control-modern"
                      rows="3"
                      placeholder="Brief summary appearing in search engine results snippets..."
                      value={myTask1?.metaDescription || ""}
                      onChange={(e) => setMyTaskValue1("", "metaDescription", e.target.value, "")}
                    ></textarea>
                  </div>
                </div>
              </div>

              {/* Bottom Actions Bar */}
              <div className="d-flex justify-content-end gap-3 my-4">
                <button
                  type="button"
                  className="btn-back-modern"
                  onClick={() => navigate("/Content")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-save-modern"
                  disabled={loading || saving}
                >
                  {saving ? (
                    <>
                      <i className="fa fa-circle-o-notch fa-spin"></i>
                      <span>Updating...</span>
                    </>
                  ) : (
                    <>
                      <i className="fa fa-check"></i>
                      <span>Save & Publish</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
